export default __webpack_public_path__ + "static/media/VIDEO_2025.bcc3d848.webm";